/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonNode
 */
export interface JsonNode {
}

/**
 * Check if a given object implements the JsonNode interface.
 */
export function instanceOfJsonNode(value: object): value is JsonNode {
    return true;
}

export function JsonNodeFromJSON(json: any): JsonNode {
    return JsonNodeFromJSONTyped(json, false);
}

export function JsonNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonNode {
    return json;
}

export function JsonNodeToJSON(json: any): JsonNode {
    return JsonNodeToJSONTyped(json, false);
}

export function JsonNodeToJSONTyped(value?: JsonNode | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

